<template>
  <v-dialog 
    width="fit-content"
    v-model="dialog">
    <template v-slot:activator="{ on }"> 
      <v-switch 
        value
        :input-value="status"
        v-on="on"
        hide-details="auto"
        class="mt-0"
        :disabled="disabled"
      >
      </v-switch>
    </template>
    <v-card
      class="card-wrapper-custom-border-radius mx-auto variantOne--text"
      width="600px"
      height="500px"
    >
      <v-row justify="end" class="mx-0 pa-6 mb-4">
        <v-btn
          @click="closeDialog"
          class="font-weight-black grey rounded-lg"
          width="10px"
          height="25px"
        >
          x
        </v-btn>
      </v-row>
      <v-card
        width="430px"
        class="px-2 px-md-0 pt-10 mt-16 mt-md-0 mx-auto transparent"
        flat
      >
        <v-img
          v-if="toStatus"
          width="100px"
          class="mx-auto mb-10"
          :src="require('@/assets/checkCircle.png')"
          ></v-img>
          <v-img
          v-else
          class="mx-auto mb-10"
          max-width="150"
          max-height="150"
          :src="require('@/assets/delete-circle.png')"
          >
        </v-img>
        <div class="d-flex justify-center mb-1 mx-4">
          <v-btn
            elevation="0"
            width="100%"
            @click="changeStatus(id)"
            height="50px"
            class="rounded-lg mb-5 text-button primary white--text">
            <span v-if="isUnit">
              {{ toStatus ? $t("core.enableUnit") : $t("core.disableUnit") }}
            </span>
            <span v-else-if="isProperty">
              {{ toStatus ? $t("core.enableProperty") : $t("core.disableProperty") }}
            </span>
            <span v-else-if="isContract">
              {{ toStatus ? "enable contract" : "disable contract" }}
            </span>
            <span v-else>
              {{ toStatus ? $t("core.enableRoom") : $t("core.disableRoom") }}
            </span>
            </v-btn>
        </div>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import { changePropertyStatus } from "../methods/change_property_status";
import { changeUnitStatus } from "../methods/change_unit_status";
import { toggleRoomStatus } from "@/landlord/methods/toggle_room_status"


export default {
  data() {
    return {
      nowStatus: null,
      dialog: false,
      initialStatus: null
    };
  },
  props: {
    isRoom: {
      type: Boolean
    },
    isUnit: {
      type: Boolean
    },
    isProperty: {
      type: Boolean
    },
    unitIdForRoom: {
      type: String,
    },
    id: {
      type: String,
      required: true
    },
    status: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    toStatus(){
      return !this.status
    }
  },
  methods: {
    closeDialog(){
      this.$root.$emit('refetchUnits')
      this.dialog = false
    },
    async changeStatus(id){
      if (this.isProperty){
        this.changePropertyStatus(id, this.toStatus)
      } else if (this.isUnit) {
        this.changeUnitStatus(id, this.toStatus)
      } else if (this.isContract) {
        this.changeContractStatus(id, this.toStatus)
      }else {
        this.changeRoomStatus(id, this.toStatus)
      }
    },
    async changeUnitStatus(id, status) {
      const variables = {
        id: id,
        status: status
      }
      const response = await changeUnitStatus(variables)
      if (response) {
        this.$root.$emit("snackbar", {
            snackbar: true,
            color: "success",
            text: this.$t("core.statusChanged"),
        });
      }
      this.closeDialog()
    },
    async changePropertyStatus(id, status) {
      const variables = {
        id: id,
        status: status
      }
      const response = await changePropertyStatus(variables)
      if (response.data.changePropertyStatus) {
        this.$root.$emit("snackbar", {
            snackbar: true,
            color: "success",
            text: this.$t("core.propertyStatusChanged"),
        });
        this.$root.$emit('refreshProperty')
        this.closeDialog()
      }
    },
    async changeRoomStatus(id, status){
      const variables = {
        unitId: this.unitIdForRoom,
        roomNumberId: id,
        status: status
      }
      const response = await toggleRoomStatus(variables)
      if (response.data.togleRoomStatus){
        if (status){
          this.$root.$emit("snackbar", {
              snackbar: true,
              color: "success",
              text: this.$t("landlord.roomEnabled"),
          });
          this.closeDialog()
        } else {
          this.$root.$emit("snackbar", {
              snackbar: true,
              color: "error",
              text: this.$t("landlord.roomDisabled"),
          });
          this.closeDialog()
        }
      }
    },
    // async changeContractStatus(id, status){
    //   const variables = {
    //     id: id,
    //     status: status
    //   }
    //   const response = await toggleContractStatus(variables)
    //   if (response.data.toggleContractStatus){
    //     if (status){
    //       this.$store.commit("SHOW_SNACKBAR", {
    //           show: true,
    //           color: "success",
    //           text: "Contract Enabled",
    //       });
    //       this.$root.$emit("updateContracts");
    //       this.closeDialog()
    //     } else {
    //       this.$store.commit("SHOW_SNACKBAR", {
    //           show: true,
    //           color: "error",
    //           text: "Contract Disabled",
    //       });
    //       this.$root.$emit("updateContracts");
    //       this.closeDialog()
    //     }
    //   }
    // },
  },
  watch: {
    status: {
      handler(){
        this.initialStatus = !this.status
        this.nowStatus = this.status
      }, immediate: true
    }
  },
  mounted(){
    this.initialStatus = !this.status
  },
}
</script>
<style scoped>
.card-wrapper-custom-border-radius {
  border-radius: 24px;
}
.card-custom-border-radius {
  border-radius: 14px;
}
.v-btn {
  min-width: 0 !important;
}
</style>